// @ts-expect-error
import protocolCheck from 'custom-protocol-detection-blockstack';
import React from 'react';

import notifications from 'notifications';

export const APP = 'desktop sync app';
const DESKTOP_URL = '/desktop';

function LaunchingAppNotice(): JSX.Element {
  const notice = `Launching ${APP}. If you don't have the app, you can download it `;
  return (
    <>
      {notice}
      <a href={DESKTOP_URL}>here</a>
    </>
  );
}

export default function openURIForEdit(uri: string, fileId: string | null = null): void {
  if (uri.startsWith('benchling:')) {
    if (fileId) {
      uri = `${uri}&documentId=${fileId}`;
    }
    protocolCheck(
      uri,
      // Browser does not support the protocol
      () => {
        notifications.info(<LaunchingAppNotice />, {duration: 10});
      },
      // Browser supports the protocol
      () => {
        notifications.info(`Opening file via ${APP}...`);
      },
      // Browser doesn't provide a method to support the protocol
      () => {
        // no detection mechanism
        notifications.info(`Attempting to launch ${APP}...`);
        window.open(uri, '_self');
      }
    );
  } else {
    window.open(uri);
  }
}
